import React, {useEffect} from 'react';
import {useMap} from 'react-leaflet';

import CustomMap from '../../../components/mazraeKit/customMap';
import {CustomMarker} from '../../../components/mazraeKit/customMap/customMarker';
import LocationClickGetter from '../../../components/mazraeKit/customMap/locationClickGetter';

interface ILatLng {
  lat: string;
  lng: string;
}

const LocationalCustomMap = ({
  location,
  latlng,
  setLatLng,
}: {
  location?: string;
  latlng: ILatLng;
  setLatLng: React.Dispatch<React.SetStateAction<ILatLng>>;
}) => {
  function getLatLng(location: string) {
    return location
      ?.split('POINT')[1]
      ?.replace(/[()]/g, '')
      ?.trim()
      ?.split(' ');
  }

  useEffect(() => {
    if (location) {
      let lat: string | undefined;
      let lng: string | undefined;

      if (location.includes('POINT')) {
        const coords = getLatLng(location);
        if (coords && coords.length === 2) [lng, lat] = coords;
      } else {
        const coords = location.split(',');
        if (coords.length === 2) [lng, lat] = coords;
      }

      if (lat && lng) {
        setLatLng({lat, lng});
      }
    }
  }, [location]);

  const RecenterAutomatically = ({lat, lng}: {lat: number; lng: number}) => {
    const map = useMap();
    useEffect(() => {
      map.setView([lat, lng]);
    }, [lat, lng]);
    return null;
  };

  const latNumber = Number(latlng.lat);
  const lngNumber = Number(latlng.lng);

  if (isNaN(latNumber) || isNaN(lngNumber)) return null;

  return (
    <CustomMap>
      <LocationClickGetter
        event={e => {
          setLatLng({
            lng: e.latlng.lng.toString(),
            lat: e.latlng.lat.toString(),
          });
        }}
      />
      <CustomMarker lat={latNumber} lng={lngNumber} />
      <RecenterAutomatically lat={latNumber} lng={lngNumber} />
    </CustomMap>
  );
};

export default LocationalCustomMap;
